import { select } from '@ngneat/elf';

import { accountStore } from './account.store';
import { getAccountDataSource } from './account.requests';
import { selectManyByPredicate, UIEntitiesRef } from '@ngneat/elf-entities';


export class AccountsQuery {
  store = accountStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  accounts$ = getAccountDataSource.data$();

  selectedAccounts$ = this.store.pipe(
    selectManyByPredicate((accountUI) => accountUI.selected, { pluck: 'id', ref: UIEntitiesRef }),
  );

  get totalRows() {
    return this.store.getValue().pagination.total;
  }
}

export const accountsQuery = new AccountsQuery();
